import { CustomPriceClass, SavedCustomPriceClass } from '../../../types/content/custom.types';

export const isPriceClassApplicable = (
  priceClass: SavedCustomPriceClass,
  defaultPriceClass: CustomPriceClass
): boolean => {
  return (
    priceClass.priceClasses[0]?.currency?.toUpperCase() === defaultPriceClass.currency?.toUpperCase() &&
    priceClass.priceClasses[0]?.quantityType === defaultPriceClass.quantityType
  );
};
